export enum CustomColumnScope {
  FINDING = "FINDING",
  PRODUCT = "PRODUCT",
  SUB_PRODUCT = "SUB_PRODUCT",
  ASSETS = "ASSETS",
  DISCOVERY = "DISCOVERY",
  ASSESSMENT = "ASSESSMENT",
}
export type CustomFindingColumn = {
  columnName: string;
  key: string;
  scope: CustomColumnScope[];
};

export type CustomFindingColumnsConfig = {
  tags: CustomFindingColumn[];
};

export type ProductSubproductTagIdentifier = {
  tagKeys: string[];
};

export type KeyValue = { key: string; value?: string };

export type ReportsConfig = {
  footerMessage?: string;
  logoFileName?: string;
  logoUrl?: string;
};

export enum RiskAssessmentTypes {
  "Text-Short" = "Text-Short",
  "Text-Long" = "Text-Long",
  "Date" = "Date",
  "Single-Select" = "Single-Select",
  "Multi-Select" = "Multi-Select",
}

export interface ArmorcodeCustomField {
  type: RiskAssessmentTypes;
  label: string;
  required?: boolean;
  values?: string[];
  id: string;
}

export type FindingCustomField = {
  label: string;
  required?: boolean;
  values?: string[];
  id: string;
  type: string;
  findingAttribute?: string;
  format?: string;
  sync?: boolean;
};

export interface ExtendedFindingCustomField extends FindingCustomField {
  unsaved?: boolean;
}
export interface DerivedAttribute {
  columnName: string;
  columnValue: string;
  id: string;
  regex: string;
  sourceAttribute: string;
  sourceAttributeDisplayName: string;
}

export enum PROPOSE_TYPE {
  PROPOSE_FALSE_POSITIVE = "PROPOSE_FALSE_POSITIVE",
  PROPOSE_SUPPRESSED = "PROPOSE_SUPPRESSED",
  PROPOSE_TRIAGE = "PROPOSE_TRIAGE",
  PROPOSE_IN_PROGRESS = "PROPOSE_IN_PROGRESS",
  PROPOSE_MITIGATED = "PROPOSE_MITIGATED",
  PROPOSE_CATEGORY = "PROPOSE_CATEGORY",
}

export interface ProposeCustomField {
  key: PROPOSE_TYPE;
  enabled: boolean;
  customFields: string[];
}
export interface FindingColumnManagementConfig {
  overrideDefaults: boolean;
  defaultColumnKeys: string[];
  forceUpdateTimeStamp: number | null;
  hideColumns: boolean;
  hiddenColumnKeys: string[];
}
export interface ColumnOption {
  key: string;
  label: string;
  disabled?: boolean;
}
